const LinkElementId = "theme-link";

import { IThemeConfig, ThemeName } from "../constants";

/**
 * @returns The link element for the current theme
 */
export const getCurrentThemeLinkElement = (): HTMLLinkElement | null => {
  return document.getElementById(LinkElementId) as HTMLLinkElement | null;
};

// Make a link element for the theme css
export const createThemeLinkElement = (
  theme: IThemeConfig,
  callback?: (themeName: ThemeName) => void
): HTMLLinkElement => {
  const linkElement = document.createElement("link");
  linkElement.setAttribute("rel", "stylesheet");
  linkElement.setAttribute("id", LinkElementId);
  linkElement.setAttribute("href", theme.cssPath);
  linkElement.setAttribute("data-theme-name", theme.name);
  if (callback) {
    linkElement.addEventListener("load", () => {
      callback(theme.name);
    });
  }
  return linkElement;
};
